module.exports = new __parcel__URL__("fud-spot-log-w.4588cb3f.png").toString();